import React, { ReactElement } from 'react';
import {
  Platform,
  TextInput,
  TextInputProps,
  TouchableOpacity,
  View,
  ViewProps,
  ViewStyle,
} from 'react-native';

import Spacing from '../../theming/Spacing';
import { useThemeContext } from '../../theming/ThemeContext';
import Icon from './Icon';
import { defaultStyles } from './styles';

interface TriggerProps extends ViewProps {
  active?: boolean;
  isValid?: boolean;
  large?: boolean;
  onPress?: () => void;
  placeholder?: string;
  placeholderTextColor?: string;
  style?: ViewStyle;
  testID?: string;
  textInputProps?: TextInputProps;
  rightElement?: ReactElement;
  value?: string;
}
const Trigger = React.forwardRef<
  React.ComponentRef<typeof TouchableOpacity>,
  TriggerProps
>((props: TriggerProps, ref) => {
  const {
    active,
    isValid = true,
    large = false,
    onBlur,
    onFocus,
    onPress,
    placeholder,
    placeholderTextColor,
    rightElement,
    style,
    testID,
    textInputProps,
    value,
    ...touchableProps
  } = props;

  const { fontFamily } = useThemeContext();

  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={onPress}
      testID={testID || 'ios_touchable_wrapper'}
      {...touchableProps}
      ref={ref}
      style={[
        defaultStyles.viewContainer,
        style,
        large ? defaultStyles.large : undefined,
        active ? defaultStyles.active : undefined,
        isValid ? undefined : defaultStyles.invalid,
      ]}
    >
      <View pointerEvents='box-only'>
        <TextInput
          editable={false}
          placeholder={placeholder}
          placeholderTextColor={placeholderTextColor}
          style={{
            ...(fontFamily ? { fontFamily } : {}),
            ...(Platform.OS === 'ios'
              ? defaultStyles.inputIOS
              : defaultStyles.inputAndroid),
            ...(large ? defaultStyles.inputLarge : {}),
            ...(!value && placeholderTextColor
              ? { color: placeholderTextColor }
              : {}),
          }}
          testID='text_input'
          value={value}
          {...textInputProps}
        />
      </View>
      {rightElement ? (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ marginRight: Spacing.l }}>{rightElement}</View>
          <Icon />
        </View>
      ) : (
        <Icon />
      )}
    </TouchableOpacity>
  );
});

export default Trigger;
